import { render, staticRenderFns } from "./app-bulk-move.vue?vue&type=template&id=7992b49a&scoped=true&"
import script from "./js/app-bulk-move.js?vue&type=script&lang=js&"
export * from "./js/app-bulk-move.js?vue&type=script&lang=js&"
import style0 from "./app-bulk-move.vue?vue&type=style&index=0&id=7992b49a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7992b49a",
  null
  
)

export default component.exports